import(/* webpackMode: "eager" */ "C:\\Users\\manito\\Documents\\ระบบทวนสอบ\\app\\src\\app\\globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\manito\\Documents\\ระบบทวนสอบ\\app\\src\\lib\\providers.tsx");
